import { gql } from '@apollo/client'

export const Query = gql`
  query AssetCase($companyId: ID!, $filters: AssetCaseFilters) {
    assetCases(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        barcode {
          id
          barcode
        }
        assetCount
        description
        warehouse {
          id
          name
        }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
